import i18n from 'i18next';
import { myLocalStorage } from '@/scripts/utils';
import { initReactI18next } from 'react-i18next';
import { languageMap } from '@/configs/i18n';

export const i18nPromise = i18n.use(initReactI18next).init({
  fallbackLng: 'en',
  resources: languageMap,
  lng: getUserLanguage(),
  interpolation: {
    escapeValue: false,
  },
});

export function getUserLanguage(): string {
  return myLocalStorage.getItem('language') || navigator.language;
}

export function setUserLanguage(language: string | undefined) {
  if (language) {
    myLocalStorage.setItem('language', language);
  } else {
    myLocalStorage.removeItem('language');
  }
}

export { i18n };
